import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import {
  apiError,
  getGateInList,
  gateInListSuccessful,
  purchaseDocSuccessful,
  gateInByIDSuccessful,
  vehicleDataSuccessful,
  purchasesImageUploadSuccessful,
  FormulaExecuterSuccessful,
  purchasesCheckApproveSuccessful,
  purchaseHistoryListSuccessful,
  saleHistoryListSuccessful,
  getPurchaseDoc,
  isRejectModelVisible,
  purchaseEnquirySuccessful,
  getPurchaseCheckApprove,
  repairAmountListSuccessful,
  reEstimationListSuccessful,
  InputChangeValue,
  addGateInSuccessful,
  getGateInListByIdSuccessful,
  vehicleImagesByIDSuccessful,
  gateInImageUploadSuccessful,
  getvehicleImagesByID,
  transferOutBySeizedIDSuccessful,
} from "./gateInSlice";
import { getVersionColors } from "../../mini/miniSlice";
import {
  getList,
  getParamsList,
  postAdd,
  postEdit,
  postFormData,
  postMultipartFormData,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import { select } from "redux-saga/effects";
import { evaluate } from "mathjs";

import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import { serialize } from "object-to-formdata";
//If user is login then dispatch redux action's are directly from here.
function* GateInList({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      // if (k === "currentSort" || k === "sortOrder") {
      //   params.ordering = data.sortOrder + data.currentSort;
      // } else {
      if (data[k] != "" && k != null && k != "no_of_pages") {
        if (k == "start_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else if (k == "end_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else {
          params[k] = data[k];
        }
      }
      // }
    }
  }
  try {
    const response = yield call(getParamsList, "/godown/gate_in/list/", params);
    yield put(gateInListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GateInListById({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      // if (k === "currentSort" || k === "sortOrder") {
      //   params.ordering = data.sortOrder + data.currentSort;
      // } else {
      if (data[k] != "" && k != null && k != "no_of_pages") {
        if (k == "start_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else if (k == "end_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else {
          params[k] = data[k];
        }
      }
      // }
    }
  }
  try {
    const response = yield call(getParamsList, `/godown/gate_in/detail/${payload.status_id}/`);
    yield put(getGateInListByIdSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}


// function* GateInAdd({ payload }) {
//   console.log("profile payload",payload)
//   const formData = serialize(payload?.profileObj);
//   console.log("payload...",formData)
//   var data = {};
//   for (const k in payload.purchaseObj) {
//     if (Object.hasOwnProperty.call(payload.purchaseObj, k)) {
//       if (payload.purchaseObj[k] !== null && payload.purchaseObj[k] !== "") {
//         data[k] = payload.purchaseObj[k];
//       }
//     }
//   }

//   try {
//     if (payload.purchaseObj.status_id == 0) {
//       const response = yield call(
//         postEdit,
//         `/godown/gate_in/detail/${payload?.purchaseObj?.id}/`,
//         payload.purchaseObj
//       );
//       if (response.status === 200 && payload.purchaseObj) {
//       const formData = serialize(payload?.profileObj);
//       const response2 = yield call(postEdit, `/godown/gateinvehicleimages/${payload?.purchaseObj?.id}/`,formData)
//        if(response2.status === 200 || 201) {
//         Modal.success({
//           icon: (
//             <span className="remix-icon">
//               <RiCheckboxCircleLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//               Gate In added successfully!
//               </p>
//             </div>
//           ),
//         });
//        }else{
//         Modal.error({
//           icon: (
//             <span className="remix-icon">
//               <RiAlertLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//                 Sorry! Unable to added Gate In. Please try again!
//               </p>
//             </div>
//           ),
//         });
//        }
//         payload.history.push("/pages/gatein");
//       } else {
//         Modal.error({
//           icon: (
//             <span className="remix-icon">
//               <RiAlertLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//                 Sorry! Unable to added Gate In. Please try again!
//               </p>
//             </div>
//           ),
//         });
//       }
//     } else {
//       const response = yield call(
//         postEdit,
//         `/godown/gate_in/detail/${payload.purchaseObj?.status_id}/`,
//         payload.purchaseObj
//       );
//       if (response.status === 200) {
//         Modal.success({
//           icon: (
//             <span className="remix-icon">
//               <RiCheckboxCircleLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//                 Gate In Vehicle Edited Successfully.!
//               </p>
//             </div>
//           ),
//         });

//         payload.history.push("/pages/gatein");
//       } else {
//         Modal.error({
//           icon: (
//             <span className="remix-icon">
//               <RiAlertLine />
//             </span>
//           ),
//           title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//           content: (
//             <div>
//               <p className="hp-p1-body hp-text-color-black-80">
//                 Sorry! Unable to edit Gate In Vehicle. Please try again!
//               </p>
//             </div>
//           ),
//         });
//       }
//     }
//     yield put(addGateInSuccessful(null));
//   } catch (error) {
//     if(error.response.status === 400){
//       Modal.error({
//         icon: (
//           <span className="remix-icon">
//             <RiAlertLine />
//           </span>
//         ),
//         title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//         content: (
//           <div>
//             <p className="hp-p1-body hp-text-color-black-80">
//               {error.response.data.error[0]}
//             </p>
//           </div>
//         ),
//       });
//     }else{
//       Modal.error({
//         icon: (
//           <span className="remix-icon">
//             <RiAlertLine />
//           </span>
//         ),

//         title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
//         content: (
//           <div>
//             <p className="hp-p1-body hp-text-color-black-80">
//               Sorry! Getting from server side issue!
//             </p>
//           </div>
//         ),
//       });
//     }

//     yield put(addGateInSuccessful(null));
//     yield put(apiError(error));
//   }
// }

function* GateInAdd({ payload }) {
  try {
    if (payload.purchaseObj.status_id == 0) {

      const { status_id, id, gatein_otherimage, gatein_video, ...filteredPurchaseObj } = payload.purchaseObj;

      // Check if we have binary files to send
      const hasBinaryFiles = gatein_otherimage || gatein_video;
      let requestData;

      if (hasBinaryFiles) {
        const formData = new FormData();

        // Add all non-file fields
        Object.entries(filteredPurchaseObj).forEach(([key, value]) => {
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        });

        // Add binary files
        if (gatein_otherimage) {
          const file = gatein_otherimage.originFileObj || gatein_otherimage;
          formData.append('gatein_otherimage', file);
        }
        if (gatein_video) {
          const file = gatein_video.originFileObj || gatein_video;
          formData.append('gatein_video', file);
        }

        requestData = formData;
      } else {
        // Filter out null or empty values for regular JSON request
        requestData = Object.entries(filteredPurchaseObj).reduce((acc, [key, value]) => {
          if (value !== null && value !== "") {
            acc[key] = value;
          }
          return acc;
        }, {});
      }

      // First API call
      const response = yield call(
        hasBinaryFiles ? postMultipartFormData : postAdd,
        `/godown/gate_in/list/`,
        requestData
      );

      if (response.status === 201 && payload.profileObj) {
        // Check if profileObj is non-empty before making the second API call
        if (payload.profileObj && Object.keys(payload.profileObj).length > 0) {
          const imageFormData = new FormData();

          // Add only the actual file objects, not the entire file structure
          Object.entries(payload.profileObj).forEach(([key, value]) => {
            if (value && value.originFileObj) {
              imageFormData.append(key, value.originFileObj);
            } else if (value && typeof value === 'object' && value.constructor === File) {
              imageFormData.append(key, value);
            }
          });

          // Second API call
          const response2 = yield call(
            postEdit,
            `/godown/seizingvehicleimages/${response?.data?.godown_vehicle?.id || response?.data?.id}`,
            imageFormData
          );

          if (response2.status === 200 || response2.status === 201) {
            Modal.success({
              icon: (
                <span className="remix-icon">
                  <RiCheckboxCircleLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
              content: (
                <div>
                  <p className="hp-p1-body hp-text-color-black-80">
                    Gate In added successfully!
                  </p>
                </div>
              ),
            });
          } else {
            Modal.error({
              icon: (
                <span className="remix-icon">
                  <RiAlertLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
              content: (
                <div>
                  <p className="hp-p1-body hp-text-color-black-80">
                    Sorry! Unable to add Gate In. Please try again!
                  </p>
                </div>
              ),
            });
          }

        } else {
          console.log("No profileObj data, skipping vehicle image upload.");
        }

        payload.history.push("/pages/gatein");
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to add Gate In. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const { status_id, id, godown_vehicle_id, gatein_otherimage, gatein_video, ...filteredPurchaseObj } = payload.purchaseObj;
      // Check if we have binary files to send
      const hasBinaryFiles = gatein_otherimage || gatein_video;
      let requestData;

      if (hasBinaryFiles) {

        const formData = new FormData();

        // Add all non-file fields
        Object.entries(filteredPurchaseObj).forEach(([key, value]) => {
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        });

        // Add binary files
        if (gatein_otherimage) {
          const file = gatein_otherimage.originFileObj || gatein_otherimage;
          formData.append('gatein_otherimage', file);
        }
        if (gatein_video) {
          const file = gatein_video.originFileObj || gatein_video;
          formData.append('gatein_video', file);
        }

        requestData = formData;
      } else {
        requestData = filteredPurchaseObj;
      }

      const response = yield call(
        hasBinaryFiles ? postMultipartFormData : postEdit,
        `/godown/gate_in/detail/${payload.purchaseObj?.status_id}/`,
        requestData
      );
      if (response.status === 200 && payload.profileObj) {
        // Check if profileObj is non-empty before making the second API call
        if (payload.profileObj && Object.keys(payload.profileObj).length > 0) {
          const imageFormData = new FormData();

          // Add only the actual file objects, not the entire file structure
          Object.entries(payload.profileObj).forEach(([key, value]) => {
            if (value && value.originFileObj) {
              imageFormData.append(key, value.originFileObj);
            } else if (value && typeof value === 'object' && value.constructor === File) {
              imageFormData.append(key, value);
            }
          });

          // Second API call
          const response2 = yield call(
            postEdit,
            `/godown/seizingvehicleimages/${response?.data?.godown_vehicle?.id}`,
            imageFormData
          );

          if (response2.status === 200 || response2.status === 201) {
            Modal.success({
              icon: (
                <span className="remix-icon">
                  <RiCheckboxCircleLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
              content: (
                <div>
                  <p className="hp-p1-body hp-text-color-black-80">
                    Gate In Edited successfully!
                  </p>
                </div>
              ),
            });
          } else {
            Modal.error({
              icon: (
                <span className="remix-icon">
                  <RiAlertLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
              content: (
                <div>
                  <p className="hp-p1-body hp-text-color-black-80">
                    Sorry! Unable to add Gate In. Please try again!
                  </p>
                </div>
              ),
            });
          }
        } else {
          console.log("No profileObj data, skipping vehicle image upload.");
        }
        payload.history.push("/pages/gatein");
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Gate In Vehicle. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
    yield put(addGateInSuccessful(null));
  } catch (error) {
    if (error.response?.status === 400) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data.error[0]}
            </p>
          </div>
        ),
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting server-side issue!
            </p>
          </div>
        ),
      });
    }

    yield put(addGateInSuccessful(null));
    yield put(apiError(error));
  }
}

// Gate In History List
function* PurchaseHistory({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/purchase/byvehicleid/" + payload.id,
      {}
    );
    yield put(purchaseHistoryListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Sale History List

function* SaleHistory({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/sale/byvehicleid/" + payload.id,
      {}
    );
    yield put(saleHistoryListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* purchaseEnquiry({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/purchase/enquiry/list/", data);
    yield put(purchaseEnquirySuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* PurchaseApproval({ payload }) {
  try {
    const response = yield call(postAdd, "/purchase/approve/", payload);
    if (response.status === 200) {
      if (payload.approvalstatus == 2) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your purchase has been approved successfully.
              </p>
            </div>
          ),
        });
      } else if (payload.approvalstatus == 3) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your purchase has been Rejected successfully.
              </p>
            </div>
          ),
        });
      }

      yield put(getPurchaseDoc(payload.purchase_id));
      yield put(getPurchaseCheckApprove({ purchase_id: payload.purchase_id }));
      yield put(isRejectModelVisible(false));
    } else {
      if (payload.approvalstatus == 2) {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Approve Gate In. Please try again!
              </p>
            </div>
          ),
        });
      } else if (payload.approvalstatus == 3) {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Reject Gate In. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}
function* PurchaseCheckApprove({ payload }) {
  try {
    const response = yield call(postAdd, "/purchase/checkapprove/", payload);
    if (response.status === 200) {
      yield put(purchasesCheckApproveSuccessful(true));
    }
  } catch (error) {
    yield put(purchasesCheckApproveSuccessful(false));
    yield put(apiError(error));
  }
}

function* PurchaseDoc({ payload }) {
  try {
    const response = yield call(getList, "/purchase/" + payload, {});
    yield put(purchaseDocSuccessful(response));
    yield put(getVersionColors(response.vehicle?.version?.model?.id));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetGateInByID({ payload }) {
  try {
    const response = yield call(getList, `/godown/gate_in/detail/${payload}/`, {});
    yield put(gateInByIDSuccessful({ response }));
    yield put(getvehicleImagesByID(response.godown_vehicle?.id))
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetTransferOutBySeizedID({ payload }) {
  try {
    const response = yield call(getList, `/godown/godown_transfer_out/byseizeid/${payload}/`, {});
    yield put(transferOutBySeizedIDSuccessful({ response }));
    // yield put(getvehicleImagesByID(response.godown_vehicle?.id))
  } catch (error) {
    yield put(apiError(error));
  }
}

function* VehicleDataGet({ payload }) {
  try {
    const response = yield call(getList, "/masters/vehicles/" + payload, {});
    yield put(vehicleDataSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* FormulaExecuter({ payload }) {
  let systemFormulasList = yield select(
    (state) => state.system.systemFormulasList
  );

  try {
    var formulaObj = systemFormulasList?.find((formula) => {
      return formula?.code === payload.code;
    });

    if (formulaObj) {
      var result = evaluate(formulaObj.formula, payload.variables);

      if (result !== "NaN") {
        yield put(
          FormulaExecuterSuccessful({
            response: result,
            formulaCode: payload.code,
          })
        );
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to calculator. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
    // try {
    //   const response = yield call(postAdd, "/system/formulaexecuter/", payload);
    //   if (response.status === 200) {
    //     yield put(
    //       FormulaExecuterSuccessful({
    //         response: response.data,
    //         formulaCode: payload.code,
    //       })
    //     );
    //   } else {
    //     Modal.error({
    //       icon: (
    //         <span className="remix-icon">
    //           <RiAlertLine />
    //         </span>
    //       ),
    //       title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
    //       content: (
    //         <div>
    //           <p className="hp-p1-body hp-text-color-black-80">
    //             Sorry! Unable to calculator. Please try again!
    //           </p>
    //         </div>
    //       ),
    //     });
    //   }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}
function* PurchasesImageUpload({ payload }) {
  try {
    const response = yield call(postFormData, "/system/attachment/", {
      file: payload.file,
    });

    yield put(
      purchasesImageUploadSuccessful({ response, ImageType: payload.imageType })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GateInDelete({ payload }) {
  try {
    const response = yield call(postDelete, `/godown/gate_in/detail/${payload.id}/`);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Gate In has been deleted!
            </p>
          </div>
        ),
      });

      yield put(getGateInList({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Gate In has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

// Repair Amount

function* RepairAmount({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/stocktransfer/repairamount/bypurchaseid/" + payload.id,
      {}
    );
    yield put(repairAmountListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Re Estimation

function* ReEstimation({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/stocktransfer/reestimationamount/bypurchaseid/" + payload.id,
      {}
    );
    yield put(reEstimationListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* InsuranceValidate({ payload }) {
  try {
    const response = yield call(
      postAdd,
      "/purchase/insurancenumber/validation/",
      payload
    );
  } catch (error) {
    if (error.response.status == 400) {
      yield put(
        InputChangeValue({
          key: "insurancenumber",
          value: "",
        })
      );
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response?.data?.error[0]}
            </p>
          </div>
        ),
      });
    } else if (error.response.status == 500) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}


function* UpdateFsyncStatus({ payload }) {
  let purchaseParamsData = yield select(
    (state) => state.purchase.purchaseParams
  )
  try {
    const response = yield call(
      postEdit,
      "/purchase/reapprove/" + payload.id, {
      approvalstatus: payload.approvalstatus,
    }
    );
    if (response.status === 200) {
      if (response.data.post_status == true) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Selected Gate In is successfully synchronised into focus
              </p>
            </div>
          ),
        });
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! selected Gate In is not posted on focus. please try
                again!
              </p>
            </div>
          ),
        });
      }
      yield put(getGateInList(purchaseParamsData));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! selected Gate In is not posted on focus. please try
              again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* VehicleImagesByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      `/godown/seizingvehicleimages/detail/${payload}`,
    );
    yield put(vehicleImagesByIDSuccessful({ response, response2: payload.response2 }));

    // yield put(isModelVisible(true));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* gateInImageImageUpload({ payload }) {
  try {
    const response = yield call(postFormData, "/system/attachment/", {
      file: payload.file,
    });

    yield put(
      gateInImageUploadSuccessful({ response, ImageType: payload.imageType })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetGateInList() {
  yield takeEvery("gateIn/getGateInList", GateInList);
}
export function* watchGetGetGateInListById() {
  yield takeEvery("gateIn/getGateInListById", GateInListById);
}
export function* watchGetvehicleImagesByID() {
  yield takeEvery("gateIn/getvehicleImagesByID", VehicleImagesByID);
}
export function* watchAddGateIn() {
  yield takeEvery("gateIn/addGateIn", GateInAdd);
}
export function* watchGetPurchaseDoc() {
  yield takeEvery("gateIn/getPurchaseDoc", PurchaseDoc);
}
export function* watchGetGateInByID() {
  yield takeEvery("gateIn/getGateInByID", GetGateInByID);
}
export function* watchGetTransferOutBySeizedID() {
  yield takeEvery("gateIn/getTransferOutBySeizedID", GetTransferOutBySeizedID);
}
export function* watchGetVehicleData() {
  yield takeEvery("gateIn/getVehicleData", VehicleDataGet);
}
export function* watchGetFormulaExecuter() {
  yield takeEvery("gateIn/getFormulaExecuter", FormulaExecuter);
}
export function* watchGetPurchasesImageUpload() {
  yield takeEvery("gateIn/getPurchasesImageUpload", PurchasesImageUpload);
}
export function* watchPurchaseApproval() {
  yield takeEvery("gateIn/purchaseApproval", PurchaseApproval);
}
export function* watchGetPurchaseCheckApprove() {
  yield takeEvery("gateIn/getPurchaseCheckApprove", PurchaseCheckApprove);
}

export function* watchGetPurchaseHistory() {
  yield takeEvery("gateIn/getPurchaseHistory", PurchaseHistory);
}

export function* watchGetSaleHistory() {
  yield takeEvery("gateIn/getSaleHistory", SaleHistory);
}
export function* watchGetPurchaseEnquiry() {
  yield takeEvery("gateIn/getPurchaseEnquiry", purchaseEnquiry);
}
export function* watchGetGateInDelete() {
  yield takeEvery("gateIn/gateInDelete", GateInDelete);
}
export function* watchGetRepairAmount() {
  yield takeEvery("gateIn/getRepairAmount", RepairAmount);
}
export function* watchGetReEstimation() {
  yield takeEvery("gateIn/getReEstimation", ReEstimation);
}
export function* watchInsuranceNumberValidate() {
  yield takeEvery("gateIn/insuranceNumberValidate", InsuranceValidate);
}
export function* watchFsyncStatusUpdate() {
  yield takeEvery("gateIn/fsyncStatusUpdate", UpdateFsyncStatus);
}
export function* watchGetGateInImageUpload() {
  yield takeEvery("gateIn/getGateInImageUpload", gateInImageImageUpload);
}
function* gateInSaga() {
  yield all([
    fork(watchGetGateInList),
    fork(watchGetGetGateInListById),
    fork(watchAddGateIn),
    fork(watchGetPurchaseDoc),
    fork(watchGetGateInByID),
    fork(watchGetVehicleData),
    fork(watchGetPurchasesImageUpload),
    fork(watchGetFormulaExecuter),
    fork(watchPurchaseApproval),
    fork(watchGetPurchaseCheckApprove),
    fork(watchGetPurchaseHistory),
    fork(watchGetSaleHistory),
    fork(watchGetPurchaseEnquiry),
    fork(watchGetGateInDelete),
    fork(watchGetRepairAmount),
    fork(watchGetReEstimation),
    fork(watchInsuranceNumberValidate),
    fork(watchGetTransferOutBySeizedID),
    fork(watchFsyncStatusUpdate),
    fork(watchGetvehicleImagesByID),
    fork(watchGetGateInImageUpload)
  ]);
}

export default gateInSaga;
